import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { StudentClassMappingCreateRequestDTO, StudentClassMappingDTO, StudentClassMappingUpdateRequestDTO, StudentClassMappingList, StudentClassMappingDeleteRequestDTO, StudentClassMappingReadByIdRequestDTO, StudentClassMappingReadByClassIdRequestDTO, StudentClassMappingReadBySectionIdRequestDTO, StudentClassMappingReadByUserIdRequestDTO, StudentClassMappingAutoAssignSectionRequestDTO } from './student-class-mapping.interface';
import { StudentClassMapping_Create, StudentClassMapping_Update, StudentClassMapping_ReadAll, StudentClassMapping_Delete, StudentClassMapping_ReadById, StudentClassMapping_ReadByClassId, StudentClassMapping_ReadBySectionId, StudentClassMapping_ReadByUserId, StudentClassMapping_AutoAssignSection } from 'src/app/GlobalVariable';

@Injectable({
  providedIn: 'root'
})
export class StudentClassMappingService {

  constructor() { }

  http = inject(HttpClient)

  StudentClassMapping_Create(data: StudentClassMappingCreateRequestDTO): Observable<StudentClassMappingDTO> {
    return this.http.post<StudentClassMappingDTO>(StudentClassMapping_Create, data)
  }

  StudentClassMapping_Update(data: StudentClassMappingUpdateRequestDTO): Observable<StudentClassMappingDTO> {
    return this.http.post<StudentClassMappingDTO>(StudentClassMapping_Update, data)
  }

  StudentClassMapping_ReadAll(): Observable<StudentClassMappingList> {
    return this.http.get<StudentClassMappingList>(StudentClassMapping_ReadAll)
  }

  StudentClassMapping_Delete(data: StudentClassMappingDeleteRequestDTO): Observable<void> {
    return this.http.post<void>(StudentClassMapping_Delete, data)
  }

  StudentClassMapping_ReadById(data: StudentClassMappingReadByIdRequestDTO): Observable<StudentClassMappingDTO> {
    return this.http.post<StudentClassMappingDTO>(StudentClassMapping_ReadById, data)
  }

  StudentClassMapping_ReadByClassId(data: StudentClassMappingReadByClassIdRequestDTO): Observable<StudentClassMappingList> {
    return this.http.post<StudentClassMappingList>(StudentClassMapping_ReadByClassId, data)
  }

  StudentClassMapping_ReadBySectionId(data: StudentClassMappingReadBySectionIdRequestDTO): Observable<StudentClassMappingList> {
    return this.http.post<StudentClassMappingList>(StudentClassMapping_ReadBySectionId, data)
  }

  StudentClassMapping_ReadByUserId(data: StudentClassMappingReadByUserIdRequestDTO): Observable<StudentClassMappingList> {
    return this.http.post<StudentClassMappingList>(StudentClassMapping_ReadByUserId, data)
  }

  StudentClassMapping_AutoAssignSection(data: StudentClassMappingAutoAssignSectionRequestDTO): Observable<void> {
    return this.http.post<void>(StudentClassMapping_AutoAssignSection, data)
  }
}
